module.exports = __webpack_public_path__ + "assets/534b011ed9ccda7b2a6915c356794c24.mp3";